import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Plot from 'react-plotly.js';

const MAX_WAV_VALUE = 32768; // (2^16 / 2) = 32768

const getWavBytes = (url) => new Promise((resolve, reject) => {
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        return reject(response.statusText);
      } else {
        return response.arrayBuffer();
      }
    })
    .then((buffer) => {
      // console.log({ buffer });
      const data = Array.from(new Int16Array(buffer, 44));
      resolve(data);
    })
    .catch((error) => {
      console.log('getWavBytes', error);
      reject(error);
    });
});

function getUiElement(fs, url) {
  return <audio src={url} controls />;
  // if (fs > 4000) {
  //   return <audio src={url} controls />;
  // } else {
  //   return (
  //     <Button
  //       variant="contained"
  //       size="small"
  //       startIcon={<SaveIcon />}
  //       onClick={() => downloadFileFromURl(url)}
  //     >
  //       Download
  //     </Button>
  //   );
  // }
}

function DebugWaveData(props) {
  const { classificationsOptions: options, user, downloadFile } = props;

  const [signalsData, setSignalsData] = React.useState([]);

  React.useEffect(() => {
    Promise.all(props.audioData.map((item) => getWavBytes(item.waveUrl)))
    .then((data) => {
      console.log('getWavBytes data', data);
      
      setSignalsData(data);
    });
  }, [props.audioData]);

  if (props.audioData == null) {
    return null;
  } else {

    const handleChange = (event, itemId) => {
      // setAge(event.target.value);
      props.setClassificationForAudio(event.target.value, itemId);
    };

    const tableBody = props.audioData.map((item, index) => (
      <tr key={item.DeviceID}>
        <td>{item.SensorIndexName}</td>
        <td>{item.SensorID}</td>
        <td>{item.DeviceID}</td>
        <td>{getUiElement(props.audioFs, item.radioUrl)}</td>
        <td>{getUiElement(props.audioFs, item.waveUrl)}</td>
        <td>{getUiElement(props.audioFs, item.waveUrlClean)}</td>
        <td>
          {signalsData[index] && <Plot
            data={[
              {
                x: signalsData[index].map((x, i) => i),
                y: signalsData[index].map((x) => x / MAX_WAV_VALUE),
                mode: 'lines',
                type: 'scatter',
                line: {
                  width: 1,
                },
              },
            ]}
            layout={{
              height: 75,
              width: 200,
              margin: { t: 0, b: 0, l: 0, r: 0 },
              yaxis: {
                range: [-0.1, 1.1],
              },
            }}
            config={{}}
          />}
        </td>
        { false && user.analysesExpert &&
          <td>
            <Select
              labelId={`audio-${item.ID}-classification-label`}
              id={`audio-${item.ID}-classification`}
              value={item.AudioClassification}
              onChange={(event) => handleChange(event, item.ID)}
            >
              <MenuItem value="">
                <em>{props.context.t('none')}</em>
              </MenuItem>
              {
                options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))
              }
            </Select>
          </td>
        }
      </tr>
    )
    );

    return (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>{props.context.t('sensor_id')}</th>
              <th>{props.context.t('device_id')}</th>
              <th>{props.context.t('radio')}</th>
              <th>{props.context.t('audio')}</th>
              <th>{props.context.t('audio_clean')}</th>
              <th>{props.context.t('signals')}</th>
              { false && user.analysesExpert &&
                <th>{props.context.t('classification')}</th>
              }
            </tr>
          </thead>
          <tbody>
            {tableBody}
          </tbody>
        </table>
    );
  }
}

export default DebugWaveData;
